var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 21,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F7F7F7",
    d: "M-132-576h1400V758H-132z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.266 1 .734.5C18.563 6.106 11.84 11.668 9.93 17.965c-1.47.68-2.833 1.198-3.968 2.035a34.945 34.945 0 0 0-2.791-4.734C2.123 13.779 1.024 12.503 0 11.776c.848-.92 1.628-1.403 2.31-1.508.746-.115 1.422.13 2.057.6 1.408 1.223 2.295 2.842 3.098 4.452C11.501 9.453 17.52 5.088 23.266 1Z",
    stroke: "#0054A6",
    fill: "#0054A6",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.cbeca52f35cfbcbb7c867ad7d38e5331.svg";
export { ForwardRef as ReactComponent };